import axios from 'axios';
import store from '@/store';
import Util from '@/common/utils/Util';
import queryString from 'query-string';
import router from '@/router';
import { ACCESS_TOKEN_NAME } from '@/common/constants/ConstCode';

let _this = null;
class ServiceExec {
  constructor() {
    let ServiceExec = axios.create({
      headers: { csrf: 'ownerAppMap' },
      withCredentials: true
    });
    // setLoading
    ServiceExec.interceptors.request.use(this.handleRequest);
    ServiceExec.interceptors.response.use(this.handleSuccess, this.handleError);
    this.ServiceExec = ServiceExec;
    this.store = store;
    this.router = router;
    _this = this;
  }

  async handleRequest(request) {
    // const token = VueCookies.get('bank_jwt_expert_token')
    // // 쿠키 토큰 없으면서 토큰 필요 api url 인경우
    // if (
    //   Util.isEmpty(token) &&
    //   ConstCode.CODE_ENV_LIST.TOKEN_CHECK_API_URL.indexOf(request.url) < 0
    // ) {
    //   await store.dispatch('expert/forceSignOut')
    //   throw false
    // }
    if (!Util.isEmpty(store)) {
      const accessToken = store.getters['expert/getAccessToken'];
      console.log('accessToken {}', accessToken);
      if (!accessToken) return request;
      request.headers[ACCESS_TOKEN_NAME] = accessToken;
    }
    await store.dispatch('layout/updateIsLoading', { isLoading: true });
    return request;
  }

  async handleSuccess(response) {
    await store.dispatch('layout/updateIsLoading', { isLoading: false });
    return response;
  }

  async refreshToken(data) {
    const params = {};
    params.userNo = data.userNo;
    const res = await _this.queryPost('/api/expert/sign/postMapChangeToken', params);
    let authToken = res.headers['bank_jwt_expert_token'];
    data = res.data.entity;
    if (!Util.isEmpty(authToken)) {
      await store.dispatch('expert/signIn', {
        accessToken: authToken,
        data: data
      });
      return true;
    } else {
      await store.dispatch('expert/forceSignOut');
      return false;
    }
  }

  async handleError(error) {
    console.log('handleError', error);
    // const data = store.getters['expert/getData'];
    await store.dispatch('layout/updateIsLoading', { isLoading: false });
    if (!error) {
      await store.dispatch('expert/forceSignOut');
      await _this.router.push({ path: '/login', query: { isRoot: 1 } });
    }
    switch (error.response.status) {
      case 401: // 권한 없음
        await store.dispatch('layout/updateIsLoading', { isLoading: false });
        await store.dispatch('expert/forceSignOut');
        await _this.router.push({ path: '/login', query: { isRoot: 1 } });
        break;
      // case 403: // expireDate 체크 -> 토큰 재발급
      //   if (!(await _this.refreshToken(data))) {
      //     return false
      //   }
      //   error.config.headers.Authorization =
      //     store.getters['expert/getAccessToken']
      //   return _this.ServiceExec.request(error.config)
      // case 404:
      //   await store.dispatch('layout/updateIsLoading', { isLoading: false })
      //   alert('서버와 통신이 원활하지 않습니다.')
      //   break
      // default:
      //   await store.dispatch('layout/updateIsLoading', { isLoading: false })
      //   alert('서버와 통신이 원활하지 않습니다.')
      //   break
    }
    return Promise.reject(error.response);
  }

  get(path, params = {}) {
    return this.ServiceExec.get(path, { params });
  }

  patch(path, payload) {
    return this.ServiceExec.request({
      method: 'PATCH',
      url: path,
      responseType: 'json',
      data: payload
    });
  }

  post(path, payload, config = {}) {
    return this.ServiceExec.request({
      headers: config.headers,
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }

  delete(path, payload) {
    payload = `${path}?${queryString.stringify(payload)}`;
    return this.ServiceExec.delete(payload);
  }

  queryPost(path, payload) {
    payload = `${queryString.stringify(payload)}`;
    return this.ServiceExec.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }

  queryMultiPost(path, payload) {
    payload = `${queryString.stringify(payload)}`;
    return this.ServiceExec.request({
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }

  multiPost(path, payload) {
    return this.ServiceExec.request({
      headers: { 'Content-Type': 'multipart/form-data' },
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload,
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader('content-length') ||
            progressEvent.target.getResponseHeader('x-decompressed-content-length');
        console.log('onUploadProgress', totalLength);
        if (totalLength !== null) {
          console.log(Math.round((progressEvent.loaded * 100) / totalLength));
        }
      }
    });
  }

  downloadStream(path, payload) {
    payload = `${queryString.stringify(payload)}`;
    return this.ServiceExec.request({
      method: 'GET',
      url: `${path}?${payload}`,
      responseType: 'blob'
    });
  }
}

export default ServiceExec;
